import { PropertiesDetailsScreen } from '@/modules/properties-web/details/PropertiesDetailsScreen';
import React from 'react';

export default function PropertiesWebDetailsRoute() {
  return <PropertiesDetailsScreen />;
}
